import { Callout } from './components/callout.tsx'
import { Xcelera } from './components/xcelera.tsx'

export const meta = () => [
	{ title: 'Scheduling Audits · xcelera docs' },
	{
		name: 'description',
		content:
			'Configure daily or interval-based schedules to run audits automatically without triggering them manually.',
	},
]

# Scheduling Audits

<Xcelera /> can automatically run audits on a recurring schedule so you don't
have to trigger them manually.

## Frequency options

Configure a schedule when creating or editing a page definition:

- **Daily** — runs once a day at a time of day you choose. A good default that balances coverage with credit usage.
- **Every N hours** — runs on a recurring interval from every hour up to once a week (1–168 hours). Use a short interval for high-traffic production pages where you need rapid regression detection, or a longer one for lower-priority pages.
- **None** — no scheduled audits. Use this if you only trigger audits manually or via the API.

Hourly-style audits land on the hour, and intervals that divide evenly into a day (every 2, 3, 4, 6, 8, or 12 hours) run at tidy clock times.

<Callout type="info">
	Scheduled audit times are managed by xcelera. If you need more control over
	exactly when audits run, use the [API or CLI](/docs/api-usage) to trigger
	audits on your own schedule, or [contact support](https://xcelera.dev/support)
	to request more granular scheduling options.
</Callout>

## How scheduling works

When a schedule is active, xcelera checks for due audits and queues them automatically. Each scheduled audit consumes one credit from your monthly allocation.

If your organization runs out of credits, scheduled audits are paused until credits reset at the start of your next billing period. See [Usage & Billing](/docs/usage-and-billing) for details.

## Managing schedules

You can change a page's schedule at any time from the page settings. Changes take effect on the next scheduled run — any audit already in progress will complete normally.

<Callout type="tip">
	Start with daily scheduling and adjust based on how quickly your site changes.
	Pages that deploy multiple times a day benefit from a short interval (every
	few hours); marketing pages that change rarely can use a longer interval.
</Callout>
